export default __webpack_public_path__ + "a2fb9e117c382b10bbd850298935757f.png";